import dateUtils from '../../assets/js/dateUtils'
import axios from 'axios'
import store from '@/store'
// import VueRouter from 'vue-router'

function getCurrentUser () {
  return window.sessionStorage.getItem('currentUserCode')
}

function getCurrentUserName () {
  return window.sessionStorage.getItem('currentUserName')
}

function getCurrentUserDept () {
  return window.sessionStorage.getItem('currentUserDept')
}

function getCurrentUserDeptName () {
  return window.sessionStorage.getItem('currentUserDeptName')
}

function getCurrentSite () {
  return window.sessionStorage.getItem('currentSite')
}

function getCurrentHrSite () {
  return window.sessionStorage.getItem('currentHrSite')
}

function getCurrentEamSite () {
  return window.sessionStorage.getItem('currentEamSite')
}

function getCurrentUserWx () {
  return window.sessionStorage.getItem('currentUserWx')
}

function getCurrentUserVend () {
  return window.sessionStorage.getItem('currentUserVend')
}

function getCurrentLang () {
  return localStorage.getItem('lang')
}

function randomString (len) {
  len = len || 10
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz'
  const maxPos = chars.length
  let pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function getCurrentDate (pattern) {
  var date = new Date()
  if ((!pattern) || (pattern === '')) {
    pattern = 'yyyy-MM-dd'
  }
  return dateUtils.formatDate(date, pattern)
}

function getCurrentMonthFirst () {
  const date = new Date()
  date.setDate(1)
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}

function getCurrentMonthLast () {
  const date = new Date()
  let currentMonth = date.getMonth()
  const nextMonth = ++currentMonth
  const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  const oneDay = 1000 * 60 * 60 * 24
  return new Date(nextMonthFirstDay - oneDay).getFullYear() + '-' +
    (new Date(nextMonthFirstDay - oneDay).getMonth() + 1) + '-' + new Date(nextMonthFirstDay - oneDay).getDate()
}

function getCurrentDateNextNM (pattern, n) {
  var date = new Date()
  if ((!pattern) || (pattern === '')) {
    pattern = 'yyyy-MM-dd'
  }
  date.setMonth(date.getMonth() + n)
  return dateUtils.formatDate(date, pattern)
}

function getCurrentDateLastD (pattern, n) {
  var date = new Date()
  if ((!pattern) || (pattern === '')) {
    pattern = 'yyyy-MM-dd'
  }
  date.setDate(date.getDate() - n)
  return dateUtils.formatDate(date, pattern)
}

// function getCurrentYear (pattern) {
//   var date = new Date()
//   if ((!pattern) || (pattern === '')) {
//     pattern = 'yyyy-MM-dd'
//   }
//   return dateUtils.formatDate(date, pattern)
// }
//
// function getCurrentMonth (pattern) {
//   var date = new Date()
//   if ((!pattern) || (pattern === '')) {
//     pattern = 'yyyy-MM-dd'
//   }
//   return dateUtils.formatDate(date, pattern)
// }

function findValueFromArrayByKey (array, keyProp, key, valueProp) {
  for (let i = 0; i < array.length; i++) {
    if (array[i][keyProp] === key) {
      return array[i][valueProp]
    }
  }
}

function getArrayObjByProp (array, prop) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].prop === prop) {
      return array[i]
    }
  }
}

function getArrayObjByDefProp (array, prop, propVal) {
  for (let i = 0; i < array.length; i++) {
    if (array[i][prop] === propVal) {
      return array[i]
    }
  }
}

function getArrayIndexByDefProp (array, prop, propVal) {
  for (let i = 0; i < array.length; i++) {
    if (array[i][prop] === propVal) {
      return i
    }
  }
}

function strToArray (arrayStr, splitStr) {
  let ary = []
  const index = arrayStr.indexOf(splitStr)
  if (index < 0) {
    ary[0] = arrayStr
  } else {
    ary = arrayStr.split(splitStr)
  }
  return ary
}

function arrayCopy (array) {
  var newobj = array.constructor === Array ? [] : {}
  if (typeof array !== 'object') {
    return
  }
  for (var i in array) {
    newobj[i] = typeof array[i] === 'object' ? arrayCopy(array[i]) : array[i]
  }
  return newobj
}

function getTypeDefaultValue (datatype) {
  if (datatype === 'boolean') {
    return false
  } else if (datatype === 'number') {
    return 0
  } else if (datatype === 'date') {
    return null
  } else {
    return ''
  }
}

function arraySortByKey (array, key) {
  return array.sort(function (obj1, obj2) {
    const x = obj1[key]
    const y = obj2[key]
    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

function newArraySortByKey (array, key) {
  const [...array2] = array
  return array2.sort(function (obj1, obj2) {
    const x = obj1[key]
    const y = obj2[key]
    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

function replaceConstValue (srcStr, constObj) {
  let rtStr = srcStr
  const appPattern = /\$APP/gi
  const sitePattern = /\$SITE/gi
  const hrSitePattern = /\$HRSITE/gi
  const eamSitePattern = /\$EAMSITE/gi
  const userPattern = /\$USER/gi
  const userNamePattern = /\$UNAME/gi
  const deptPattern = /\$UDEPT/gi
  const deptNamePattern = /\$UDEPTNAME/gi
  const langPattern = /\$LANG/gi
  const lastYearPattern = /\$LASTYEAR/gi
  const thisYearPattern = /\$THISYEAR/gi
  const nextYearPattern = /\$NEXTYEAR/gi
  const lastMonthPattern = /\$LASTMONTH/gi
  const thisMonthPattern = /\$THISMONTH/gi
  const nextMonthPattern = /\$NEXTMONTH/gi
  const todayPattern = /\$TODAY/gi
  const thisTimePattern = /\$THISTIME/gi
  const mnidPattern = /\$MNID/gi
  const modifyAllPattern = /\$MODIFYALL/gi // 查看所有单据
  const mnuserPermPattern = /\$MNUSERPERM/gi // 查看用户权限单据
  rtStr = rtStr.replace(appPattern, constObj.APP)
  rtStr = rtStr.replace(sitePattern, constObj.SITE)
  rtStr = rtStr.replace(hrSitePattern, constObj.HRSITE)
  rtStr = rtStr.replace(eamSitePattern, constObj.EAMSITE)
  rtStr = rtStr.replace(userPattern, constObj.USER)
  rtStr = rtStr.replace(langPattern, constObj.LANG)
  rtStr = rtStr.replace(lastYearPattern, constObj.LASTYEAR)
  rtStr = rtStr.replace(thisYearPattern, constObj.THISYEAR)
  rtStr = rtStr.replace(nextYearPattern, constObj.NEXTYEAR)
  rtStr = rtStr.replace(lastMonthPattern, constObj.LASTMONTH)
  rtStr = rtStr.replace(thisMonthPattern, constObj.THISMONTH)
  rtStr = rtStr.replace(nextMonthPattern, constObj.NEXTMONTH)
  rtStr = rtStr.replace(todayPattern, constObj.TODAY)
  rtStr = rtStr.replace(thisTimePattern, constObj.THISTIME)
  rtStr = rtStr.replace(mnidPattern, constObj.MNID)
  rtStr = rtStr.replace(userNamePattern, constObj.UNAME)
  rtStr = rtStr.replace(deptPattern, constObj.UDEPT)
  rtStr = rtStr.replace(deptNamePattern, constObj.UDEPTNAME)
  rtStr = rtStr.replace(modifyAllPattern, constObj.MODIFYALL)
  rtStr = rtStr.replace(mnuserPermPattern, constObj.MNUSERPERM)
  return rtStr
}

function getSqlValue (dataType, value) {
  if (dataType === 'boolean') {
    if (value === true) {
      return 1
    } else {
      return 0
    }
  } else if (dataType === 'number') {
    return value
  } else if (dataType === 'date') {
    return "'" + dateUtils.formatDate(value, 'yyyy-MM-dd') + "'"
  } else {
    return "'" + value + "'"
  }
}

function toInt (number) {
  return number * 1 | 0 || 0
}

function getDefaultValue (def, datatype) {
  if (def === '$USER') {
    return this.getCurrentUser()
  } else if (def === '$UNAME') {
    return this.getCurrentUserName()
  } else if (def === '$UDEPT') {
    return this.getCurrentUserDept()
  } else if (def === '$UDEPTNAME') {
    return this.getCurrentUserDeptName()
  } else if (def === '$SITE') {
    return this.getCurrentSite()
  } else if (def === '$HRSITE') {
    return this.getCurrentHrSite()
  } else if (def === '$EAMSITE') {
    return this.getCurrentEamSite()
  } else if (def === '$LANG') {
    return this.getCurrentLang()
  } else if (def === '$THISYEAR') {
    return this.getCurrentDate('Y')
  } else if (def === '$LASTMONTH') {
    return this.toInt(this.getCurrentDate('M')) - 1
  } else if (def === '$THISMONTH') {
    return this.toInt(this.getCurrentDate('M'))
  } else if (def === '$NEXTMONTH') {
    return this.toInt(this.getCurrentDate('M')) + 1
  } else if (def === '$TODAY') {
    return this.getCurrentDate('yyyy-MM-dd')
  } else if (def === '$NEXTTWOMONTH') {
    return this.getCurrentDateNextNM('yyyy-MM-dd', 2)
  } else if (def === '$THISTIME') {
    return this.getCurrentDate('yyyy-MM-dd HH:mm')
  } else if (def === '$TRUE') {
    return true
  } else if (def === '$FALSE') {
    return false
  } else if (def === '$VEND') {
    return this.getCurrentUserVend()
  } else {
    if (datatype === 'boolean') {
      return false
    } else if (datatype === 'number') {
      return Number(def)
    } else if (datatype === 'date') {
      return null
    } else {
      return def
    }
  }
}

function updateObjProp (obj, prop, value) {
  obj[prop] = value
}

async function checkPerm (user, perm) {
  if (perm === '*') {
    return true
  } else {
    const para = {
      user: user,
      perm: perm
    }
    const { data: res } = await axios.post('/users/checkPerm', para)
    if (res) {
      const allow = res.allow
      if (allow === 1) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}

async function checkPermBySysCfg (user, sysCfgCode, sysCfgField) {
  const spara = {
    sysCode: sysCfgCode,
    sysField: sysCfgField
  }
  const { data: ress } = await axios.post('/users/selectValueByField', spara)
  if (ress.data) {
    const perm = ress.data
    if (perm === '*') {
      return true
    } else {
      const para = {
        user: user,
        perm: perm
      }
      const { data: res } = await axios.post('/users/checkPerm', para)
      if (res) {
        const allow = res.allow
        if (allow === 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}

async function getMapkvOptions (mapkvCode, constObj) {
  if (mapkvCode === '') {
    return {}
  }
  const options = {
    key: 'mapkvdKey',
    value: 'mapkvdValue',
    label: 'mapkvdLabel',
    tagUsed: false,
    tagType: 'default',
    options: []
  }
  const masterUrl = '/users/getMapkvMstrByCode'
  const masterPara = { mapkvCode: mapkvCode }
  const { data: res } = await axios.post(masterUrl, masterPara)
  if (res.data) {
    options.tagUsed = (res.data.mapkvTagUsed === 'undefined') ? false : res.data.mapkvTagUsed
    options.tagType = (res.data.mapkvTagType === 'undefined' || res.data.mapkvTagType === '') ? 'default' : res.data.mapkvTagType
    const mapkvType = res.data.mapkvType
    /* 动态键值对 */
    if (mapkvType === 'A') {
      options.key = res.data.mapkvKey
      options.value = res.data.mapkvValue
      options.label = res.data.mapkvLabel
      let para = {}
      if ((res.data.mapkvPara) && (res.data.mapkvPara !== '')) {
        let mp = res.data.mapkvPara
        if (constObj) {
          mp = replaceConstValue(mp, constObj)
        }
        para = JSON.parse(mp)
      }
      if ((res.data.mapkvUrl) && (res.data.mapkvUrl !== '')) {
        const { data: res2 } = await axios.post(res.data.mapkvUrl, para)
        options.options = res2.data
      }
      options.options = options.options.map(function (item) {
        return {
          ...item, // 使用扩展运算符复制原始对象的其他属性
          mapkvdEffect: 'xxx', // 添加新的属性
          mapkvdColor: 'red' // 添加新的属性
        }
      })
    } else {
      /* 固定键值对 */
      const detUrl = '/users/getListMapkvdDetUsed'
      const detPara = { mapkvdCode: mapkvCode }
      const { data: res3 } = await axios.post(detUrl, detPara)
      options.options = res3.data
    }
  }
  return options
}

async function getMultitkOptions (codesStr) {
  if (codesStr === '') {
    return {}
  }
  const options = {
    key: 'tkCode',
    value: 'tkCode',
    label: 'tkName',
    options: []
  }
  const masterUrl = '/tk/getMultitkOptions'
  const masterPara = {
    codesStr: codesStr
  }
  const { data: res } = await axios.post(masterUrl, masterPara)
  if (res.data) {
    options.options = res.data
  }
  return options
}

async function getHrgendOptions (hrgendCode, hrgendSite) {
  if (hrgendCode === '') {
    return {}
  }
  const options = {
    key: 'hrgendCategory',
    value: 'hrgendCategory',
    label: 'hrgendProperty',
    options: []
  }
  const masterUrl = '/hr/getListHrgendByCode'
  const masterPara = {
    hrgendSite: hrgendSite,
    hrgendCode: hrgendCode
  }
  const { data: res } = await axios.post(masterUrl, masterPara)
  if (res.data) {
    options.options = res.data
  }
  return options
}

async function bindValidator (value, callback, context, currObj, oldValue, objState, postState, udefFunc) {
  if (value === oldValue) {
    return callback()
  } else {
    let udefunc = null
    udefunc = null
    // eslint-disable-next-line no-eval
    eval('udefunc=' + udefFunc)
    const res = await udefunc(value, context, oldValue, currObj, objState, postState)
    if (res.flag === -1) {
      return callback()
    } else {
      return callback(new Error(res.msg))
    }
  }
}

async function bindValidatorChange (value, callback, context, currObj, oldValue, objState, postState, udefFunc) {
  let udefunc = null
  udefunc = null
  // eslint-disable-next-line no-eval
  eval('udefunc=' + udefFunc)
  const res = await udefunc(value, context, oldValue, currObj, objState, postState)
  if (res.flag === -1) {
    return callback()
  } else {
    return callback(new Error(res.msg))
  }
}

async function bindValidatorSet (value, callback, context, currObj, oldValue, objState, postState, udefFunc) {
  if ((value === oldValue) || (postState)) {
    return callback()
  } else {
    let udefunc = null
    udefunc = null
    // eslint-disable-next-line no-eval
    eval('udefunc=' + udefFunc)
    const res = await udefunc(value, context, oldValue, currObj, objState)
    if (res.flag === -1) {
      return callback()
    } else {
      return callback(new Error(res.msg))
    }
  }
}

function base64ToBlob (base64Str, contentType) {
  // const parts = base64Str.split(';base64,')
  // const contentType = parts[0].split(':')[1]
  const raw = window.atob(base64Str)
  const rawLength = raw.length
  const uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], { type: contentType })
}

async function loadColumnsByMhobj (objCode, constObj_) {
  const columns = []
  if ((!objCode) || (objCode === '')) {
    return columns
  }
  const uuId = getCurrentUser()
  const lang = getCurrentLang()
  const para = {
    mhobjCode: objCode,
    mhobjdCode: objCode,
    mhobjLang: lang,
    mhobjApp: '',
    mhobjSite: ''
  }
  const { data: res } = await axios.post('/users/queryByObj', para)
  if (res.data) {
    const list = res.data.mhobjdDetList
    for (const i in list) {
      const maplist = await getMapkvOptions(list[i].mhobjdMapvalues, constObj_)
      let allow = true
      if (list[i].mhobjdFieldPerm !== '') {
        allow = await checkPerm(uuId, list[i].mhobjdFieldPerm)
      }
      let gridSlot = []
      if (list[i].mhobjdGridSlot !== '') {
        gridSlot = JSON.parse(list[i].mhobjdGridSlot)
      }
      columns.push({
        key: list[i].mhobjdProp,
        col: list[i].mhobjdCols,
        row: list[i].mhobjdRows,
        align: list[i].mhobjdGridAlign,
        textRows: list[i].mhobjdMin,
        type: list[i].mhobjdType,
        prop: list[i].mhobjdProp,
        label: list[i].mhobjdLabel,
        width: list[i].mhobjdWidth,
        mainKey: list[i].mhobjdMainKey,
        required: list[i].mhobjdRequired,
        clearable: list[i].mhobjdClearable,
        display: list[i].mhobjdDisplay && allow,
        formDisplay: list[i].mhobjdFormDisplay && allow,
        order: list[i].mhobjdOrder,
        formOrder: list[i].mhobjdFormOrder,
        typeExtends: list[i].mhobjdTypeExtends,
        readOnly: list[i].mhobjdReadonly,
        default: list[i].mhobjdDefault,
        format: list[i].mhobjdFormat,
        hq: list[i].mhobjdHq,
        rstField: '',
        ref: list[i].mhobjdRef,
        refObj: list[i].mhobjdRefObj,
        refObjCond: list[i].mhobjdRefCondition,
        validType: list[i].mhobjdValidatorType,
        validator: list[i].mhobjdValidator,
        overToolTip: list[i].mhobjdOvertooltip,
        efileParas: list[i].mhobjdFileParas,
        gridSort: list[i].mhobjdGridSort,
        gridFixed: list[i].mhobjdGridFixed,
        gridSlot: gridSlot,
        mapValues: maplist
      })
    }
  }
  return columns
}

async function loadColumnsByMhobj2 (objCode, constObj_, currentObj) {
  const resultObj = {
    columns: [],
    rules: []
  }
  const columns = []
  const rules = []
  if ((!objCode) || (objCode === '')) {
    return columns
  }
  const uuId = getCurrentUser()
  const lang = getCurrentLang()
  const para = {
    mhobjCode: objCode,
    mhobjdCode: objCode,
    mhobjLang: lang,
    mhobjApp: '',
    mhobjSite: ''
  }
  const { data: res } = await axios.post('/users/queryByObj', para)
  if (res.data) {
    const list = res.data.mhobjdDetList
    for (const i in list) {
      const maplist = await getMapkvOptions(list[i].mhobjdMapvalues, constObj_)
      let allow = true
      if (list[i].mhobjdFieldPerm !== '') {
        allow = await checkPerm(uuId, list[i].mhobjdFieldPerm)
      }
      const onInsertStr = list[i].mhobjdOninsert
      let onInsert = {}
      if (onInsertStr !== '') {
        onInsert = JSON.parse(onInsertStr)
      }
      let gridSlot = []
      if (list[i].mhobjdGridSlot !== '') {
        gridSlot = JSON.parse(list[i].mhobjdGridSlot)
      }
      columns.push({
        key: list[i].mhobjdProp,
        col: list[i].mhobjdCols,
        row: list[i].mhobjdRows,
        align: list[i].mhobjdGridAlign,
        textRows: list[i].mhobjdMin,
        type: list[i].mhobjdType,
        prop: list[i].mhobjdProp,
        label: list[i].mhobjdLabel,
        width: list[i].mhobjdWidth,
        mainKey: list[i].mhobjdMainKey,
        required: list[i].mhobjdRequired,
        clearable: list[i].mhobjdClearable,
        display: list[i].mhobjdDisplay && allow,
        formDisplay: list[i].mhobjdFormDisplay && allow,
        order: list[i].mhobjdOrder,
        formOrder: list[i].mhobjdFormOrder,
        typeExtends: list[i].mhobjdTypeExtends,
        readOnly: list[i].mhobjdReadonly,
        default: list[i].mhobjdDefault,
        format: list[i].mhobjdFormat,
        hq: list[i].mhobjdHq,
        rstField: '',
        ref: list[i].mhobjdRef,
        refObj: list[i].mhobjdRefObj,
        refObjCond: list[i].mhobjdRefCondition,
        validType: list[i].mhobjdValidatorType,
        validator: list[i].mhobjdValidator,
        overToolTip: list[i].mhobjdOvertooltip,
        efileParas: list[i].mhobjdFileParas,
        gridSort: list[i].mhobjdGridSort,
        gridFixed: list[i].mhobjdGridFixed,
        zeroShow: list[i].mhobjdZeroShow,
        gridSlot: gridSlot,
        onInsert: onInsert,
        mapValues: maplist
      })
      const aRules = []
      if (list[i].mhobjdRequired === true) {
        aRules.push({
          required: true,
          message: list[i].mhobjdLabel + '不能为空!',
          trigger: 'blur'
        })
      }
      if ((list[i].mhobjdLength > 0) && (list[i].mhobjdType === 'string')) {
        aRules.push({
          max: list[i].mhobjdLength,
          message: '字符长度不能超过' + list[i].mhobjdLength,
          trigger: 'blur'
        })
      }
      if (list[i].mhobjdValidator !== '') {
        aRules.push({
          validator: (rule, value, callback) => {
            const oldValue = currentObj._ObjectPropsOld[list[i].mhobjdProp]
            bindValidator(value, callback, this, currentObj, oldValue, currentObj._state, currentObj._post, list[i].mhobjdValidator)
          },
          trigger: 'blur'
        })
      }
      if (list[i].mhobjdOnset !== '') {
        aRules.push({
          validator: (rule, value, callback) => {
            const oldValue = currentObj._ObjectPropsOld[list[i].mhobjdProp]
            bindValidatorSet(value, callback, this, currentObj, oldValue, currentObj._state, currentObj._post, list[i].mhobjdOnset)
          },
          trigger: 'blur'
        })
      }
      if (list[i].mhobjdValidatorChange !== '') {
        aRules.push({
          validator: (rule, value, callback) => {
            const oldValue = currentObj._ObjectPropsOld[list[i].mhobjdProp]
            bindValidatorChange(value, callback, this, currentObj, oldValue, currentObj._state, currentObj._post, list[i].mhobjdValidatorChange)
          },
          trigger: 'change'
        })
      }
      rules.push(aRules)
    }
    resultObj.columns = columns
    resultObj.rules = rules
  }
  return resultObj
}

async function autoNbr (code) {
  let nbr = ''
  if (code === '') {
    return nbr
  }
  if ((code) && (code !== '')) {
    const p = {
      code_code: code,
      ord_nbr: '',
      flag: -1,
      msg: '',
      lang: getCurrentLang()
    }
    const { data: res } = await axios.post('/users/autoNbr', p)
    if (res.flag) {
      const flag = res.flag
      if (flag === -1) {
        nbr = res.ord_nbr
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(nbr)
  })
}

// async function hrAutoNbr (code, site) {
//   let nbr = ''
//   site = site.replace(/\$HRSITE/gi, site)
//   if (code === '' || site === '') {
//     return nbr
//   }
//   if ((code) && (code !== '')) {
//     const p = {
//       code_code: code,
//       code_site: site,
//       ord_nbr: '',
//       flag: -1,
//       msg: '',
//       lang: getCurrentLang()
//     }
//     const { data: res } = await axios.post('/hr/hrAutoNbr', p)
//     if (res.flag) {
//       const flag = res.flag
//       if (flag === -1) {
//         nbr = res.ord_nbr
//       }
//     }
//   }
//   return new Promise((resolve, reject) => {
//     resolve(nbr)
//   })
// }
async function hrAutoNbr (code) {
  let nbr = ''
  if (code === '') {
    return nbr
  }
  if ((code) && (code !== '')) {
    const p = {
      code_code: code,
      ord_nbr: '',
      flag: -1,
      msg: '',
      lang: getCurrentLang()
    }
    const { data: res } = await axios.post('/hr/autoNbr', p)
    if (res.flag) {
      const flag = res.flag
      if (flag === -1) {
        nbr = res.ord_nbr
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(nbr)
  })
}

async function scmAutoNbr (code) {
  let nbr = ''
  if (code === '') {
    return nbr
  }
  if ((code) && (code !== '')) {
    const p = {
      code_code: code,
      ord_nbr: '',
      flag: -1,
      msg: '',
      lang: getCurrentLang()
    }
    const { data: res } = await axios.post('/scm/autoNbr', p)
    if (res.flag) {
      const flag = res.flag
      if (flag === -1) {
        nbr = res.ord_nbr
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(nbr)
  })
}

async function eamAutoNbr (code) {
  let nbr = ''
  if (code === '') {
    return nbr
  }
  if ((code) && (code !== '')) {
    const p = {
      code_code: code,
      ord_nbr: '',
      flag: -1,
      msg: '',
      lang: getCurrentLang()
    }
    const { data: res } = await axios.post('/eam/autoNbr', p)
    if (res.flag) {
      const flag = res.flag
      if (flag === -1) {
        nbr = res.ord_nbr
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(nbr)
  })
}

async function plmAutoNbr (code) {
  let nbr = ''
  if (code === '') {
    return nbr
  }
  if ((code) && (code !== '')) {
    const p = {
      code_code: code,
      ord_nbr: '',
      flag: -1,
      msg: '',
      lang: getCurrentLang()
    }
    const { data: res } = await axios.post('/plm/autoNbr', p)
    if (res.flag) {
      const flag = res.flag
      if (flag === -1) {
        nbr = res.ord_nbr
      }
    }
  }
  return new Promise((resolve, reject) => {
    resolve(nbr)
  })
}

async function getNewLine (url, para) {
  const { data: res } = await axios.post(url, para)
  return new Promise((resolve, reject) => {
    resolve(res)
  })
}

async function getStaticRouter (staticCode) {
  const p = {
    staticCode: staticCode
  }
  let staticRouter = null
  const { data: res } = await axios.post('/users/getStaticRouterById', p)
  if (res.data) {
    staticRouter = res.data
  }
  return staticRouter
}

function getViews (path) {
  return resolve => {
    require.ensure([], (require) => {
      resolve(require('@/' + path + '.vue'))
    })
  }
}

function getView (path) {
  return resolve => {
    require.ensure([], (require) => {
      resolve(require(path + '.vue'))
    })
  }
}

async function addStaticRouterUrl (staticCode, nbr, router) {
  let stl = null
  const staticRouter = await getStaticRouter(staticCode)
  if (staticRouter) {
    const view = getViews(staticRouter.staticPath)
    const link = staticRouter.staticPath
    // const nameComponent = {}
    // nameComponent[nbr] = view
    stl = {
      path: '/' + staticRouter.staticLink + nbr,
      name: nbr,
      component: view,
      meta: {
        link: link,
        title: nbr,
        id: nbr,
        vuename: staticRouter.staticVueName,
        paras: '',
        keeplive: staticRouter.staticKeepLive
      }
    }

    let flag = true
    const thisRouter = router.options.routes
    for (const i in thisRouter) {
      if (thisRouter[i].name === stl.name) {
        flag = false
      }
    }
    if (flag) {
      router.options.routes.push(stl)
      // router.matcher = new VueRouter().matcher
      router.$addRoutes(router.options.routes)
      // router.addRoutes(router.options.routes)
    }
  }
  return stl
}

async function getStaticRouterUrl (staticCode, nbr) {
  let stl = null
  const staticRouter = await getStaticRouter(staticCode)
  if (staticRouter) {
    const view = getViews(staticRouter.staticPath)
    const link = staticRouter.staticPath
    const nameComponent = {}
    nameComponent[nbr] = view
    stl = {
      path: staticRouter.staticLink + nbr,
      name: nbr,
      components: nameComponent,
      meta: {
        link: link,
        title: nbr,
        id: nbr,
        vuename: staticRouter.staticVueName,
        paras: '',
        keeplive: staticRouter.staticKeepLive
      }
    }
  }
  return stl
}

function pushRouter (router, newRoute, name, paras) {
  if (newRoute) {
    let flag = true
    const thisRouter = router.options.routes[2].children
    for (const i in thisRouter) {
      if (thisRouter[i].name === newRoute.name) {
        flag = false
      }
    }
    if (flag) {
      if (newRoute.meta.keeplive) {
        store.commit('cacheTabs/setKeepAliveList', newRoute.meta.vuename)
      }
      router.options.routes[2].children.push(newRoute)
      // router.matcher = new VueRouter().matcher
      router.$addRoutes(router.options.routes)
    }
  }
  router.push({
    name: name,
    params: paras
    // eslint-disable-next-line handle-callback-err
  }).catch(err => {})
}

export default {
  getCurrentUser: getCurrentUser,
  getCurrentUserName: getCurrentUserName,
  getCurrentUserDept: getCurrentUserDept,
  getCurrentUserDeptName: getCurrentUserDeptName,
  getCurrentSite: getCurrentSite,
  getCurrentHrSite: getCurrentHrSite,
  getCurrentEamSite: getCurrentEamSite,
  getCurrentLang: getCurrentLang,
  getCurrentUserWx: getCurrentUserWx,
  getCurrentUserVend: getCurrentUserVend,
  getCurrentDate: getCurrentDate,
  getCurrentMonthFirst: getCurrentMonthFirst,
  getCurrentMonthLast: getCurrentMonthLast,
  getCurrentDateNextNM: getCurrentDateNextNM,
  getCurrentDateLastD: getCurrentDateLastD,
  getArrayObjByProp: getArrayObjByProp,
  getArrayObjByDefProp: getArrayObjByDefProp,
  getArrayIndexByDefProp: getArrayIndexByDefProp,
  findValueFromArrayByKey: findValueFromArrayByKey,
  getMapkvOptions: getMapkvOptions,
  getMultitkOptions: getMultitkOptions,
  getHrgendOptions: getHrgendOptions,
  strToArray: strToArray,
  toInt: toInt,
  getDefaultValue: getDefaultValue,
  getTypeDefaultValue: getTypeDefaultValue,
  arraySortByKey: arraySortByKey,
  newArraySortByKey: newArraySortByKey,
  arrayCopy: arrayCopy,
  bindValidator: bindValidator,
  bindValidatorChange: bindValidatorChange,
  bindValidatorSet: bindValidatorSet,
  updateObjProp: updateObjProp,
  replaceConstValue: replaceConstValue,
  getSqlValue: getSqlValue,
  base64ToBlob: base64ToBlob,
  loadColumnsByMhobj: loadColumnsByMhobj,
  loadColumnsByMhobj2: loadColumnsByMhobj2,
  getStaticRouter: getStaticRouter,
  getStaticRouterUrl: getStaticRouterUrl,
  checkPerm: checkPerm,
  pushRouter: pushRouter,
  addStaticRouterUrl: addStaticRouterUrl,
  getViews: getViews,
  getView: getView,
  autoNbr: autoNbr,
  hrAutoNbr: hrAutoNbr,
  scmAutoNbr: scmAutoNbr,
  eamAutoNbr: eamAutoNbr,
  plmAutoNbr: plmAutoNbr,
  getNewLine: getNewLine,
  checkPermBySysCfg: checkPermBySysCfg,
  randomString: randomString
}
